import { UserRole } from '~/enums'

export const holdsCustomerRole = (roles: readonly UserRole[]): boolean =>
  roles.includes(UserRole.CUSTOMER)
